/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { createTemplateTask, ScanTemplatePartContext, ScanTemplateRoot, ScanTemplateTask } from '@kaiizen/kai-scan-template-system';
import { ScanTemplateDataMutators } from '../../State';
import { Button, PageSubHeaderBar } from '../../Widgets';
import { TemplateTasksEditor } from './TemplateTasksEditor';

const ALL_TASKS_CONTAINER_STYLE = css`
  label: ALL_TASKS_CONTAINER_STYLE;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  height: 100%;
  background: var(--background);
  overflow: hidden; /* Prevent horizontal scrolling on the main container */
`;
export const AllTemplateTasksEditor = ({
  selectedScanTemplatePartContext,
  setSelectedScanTemplatePartContext,
  templateRoot,
  scanTemplateDataMutators,
  filterRegex,
  filteredTasks,
  allTasks,
  readOnly,
}: {
  selectedScanTemplatePartContext: ScanTemplatePartContext | null;
  setSelectedScanTemplatePartContext: (context: ScanTemplatePartContext | null) => void;
  templateRoot: ScanTemplateRoot;
  scanTemplateDataMutators: ScanTemplateDataMutators;
  filterRegex?: RegExp;
  allTasks: ScanTemplateTask[];
  filteredTasks: ScanTemplateTask[];
  readOnly?: boolean;
}) => {
  const handleCreateNewTask = () => {
    const newTask = createTemplateTask({ name: 'New Task' });
    scanTemplateDataMutators.addTask(undefined, newTask, 0);
    setSelectedScanTemplatePartContext({ taskId: newTask.id });
  };

  return (
    <div css={ALL_TASKS_CONTAINER_STYLE}>
      <PageSubHeaderBar
        title={`${filteredTasks.length < allTasks.length ? `${filteredTasks.length.toString()}/${allTasks.length.toString()} Filtered Tasks` : 'All Tasks'}`}
        buttons={readOnly ? [] : [
          <Button key='new-task' onClick={handleCreateNewTask}>
            Add Task
          </Button>,
        ]}
      />
      <TemplateTasksEditor
        tasks={filteredTasks}
        templateRoot={templateRoot}
        selectedScanTemplatePartContext={selectedScanTemplatePartContext}
        setSelectedScanTemplatePartContext={setSelectedScanTemplatePartContext}
        filterRegex={filterRegex}
      />
    </div>
  );
};
